import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Switch,
  FormControlLabel,
  Paper
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import moment from 'moment';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {
  ImportVehicleVQRequeryAttachment,
  VehicleVQRequery,
  VehicleVQRequeryImportedDto,
  VehicleVQRequeryImportRequestDto
} from '../../../interfaces/Case';
import MaterialTable from 'material-table';
import { getLocalization, MaterialTableIcons } from '../../_shared/TableSettings';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import FileUploadRow from '../../_shared/FileUploadRow';
import FileSaver from 'file-saver';
import { ImportTemplateCodeEnum } from '../../../helpers/Constants';

interface IVehicleVQRequeryComponentState {
  newVehicleVQRequery: VehicleVQRequery;
  vehicleVQRequeryList: VehicleVQRequery[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newVehicleVQRequeryId: number | null;
  isLoadingImportData: boolean;
  isDownloading: boolean;
  isImportDialogOpen: boolean;
  attachments: ImportVehicleVQRequeryAttachment[];
  importedVehicleVQRequeryList: VehicleVQRequeryImportedDto[];
}
type IVehicleVQRequeryComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class VehicleVQRequeryComponent extends React.PureComponent<
  IVehicleVQRequeryComponentProps,
  IVehicleVQRequeryComponentState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  static contextType = ApplicationContext;
  private newVehicleVQRequery = {
    id: 0,
    vin: '',
    isActive: true,
    dateCreation: null,
    dateModification: null,
    createdBy: null,
    modifiedBy: null
  } as VehicleVQRequery;

  state = {
    vehicleVQRequeryList: [],
    isLoading: false,
    isDialogOpen: false,
    newVehicleVQRequery: this.newVehicleVQRequery,
    newVehicleVQRequeryId: null,
    isImportDialogOpen: false,
    isLoadingImportData: false,
    isDownloading: false,
    attachments: [] as ImportVehicleVQRequeryAttachment[],
    importedVehicleVQRequeryList: [] as VehicleVQRequeryImportedDto[]
  } as IVehicleVQRequeryComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const vehicleVQRequeryList = await this.caseService.VehicleVQRequeryList();

    this.setState({
      vehicleVQRequeryList: vehicleVQRequeryList,
      isLoading: false,
      newVehicleVQRequery: { ...this.newVehicleVQRequery }
    });
  };

  private handleVinChange = (value: string) => {
    this.setState({
      newVehicleVQRequery: {
        ...this.state.newVehicleVQRequery,
        vin: value
      }
    });
  };

  private handleIsActiveChange = (checked: boolean) => {
    this.setState({
      newVehicleVQRequery: {
        ...this.state.newVehicleVQRequery,
        isActive: checked
      }
    });
  };

  private vinValidation = () => {
    const vinRegex =
      /^(?=.*[0-9])(?=.*[abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ])[0-9abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ-]{17}$/;
    if (!vinRegex.test(this.state.newVehicleVQRequery.vin || '')) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'INVALID_CAR_VIN_IDENTIFICATOR',
          "Te rugăm să te asiguri că seria de șasiu introdusă  are 17 caractere alfanumerice și nu conține spații sau literele 'O' sau 'I'!"
        ),
        { variant: 'warning' }
      );
    }
  };

  public saveVehicleVQRequery = async () => {
    if (this.state.newVehicleVQRequeryId === null) {
      if (
        this.state.vehicleVQRequeryList.findIndex(
          (item) => item.vin === this.state.newVehicleVQRequery.vin
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_VIN_EXISTS',
            'VIN-ul introdus exista deja in lista'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.caseService.AddVehicleVQRequery(this.state.newVehicleVQRequery);
        await this.loadData();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      if (
        this.state.vehicleVQRequeryList.findIndex(
          (item) =>
            item.id !== this.state.newVehicleVQRequeryId &&
            item.vin === this.state.newVehicleVQRequery.vin
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_VIN_EXISTS',
            'VIN-ul introdus exista deja in lista'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.caseService.UpdateVehicleVQRequery(this.state.newVehicleVQRequery);
        await this.loadData();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveVehicleVQRequery} instantValidate={true}>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="vin"
            id="vin"
            value={this.state.newVehicleVQRequery.vin || ''}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            onChange={(e: any) => this.handleVinChange(e.target.value)}
            onBlur={this.vinValidation}
            label={this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_VIN_LABEL', 'VIN')}
            validators={[
              'required',
              'matchRegexp:^(?=.*[0-9])(?=.*[abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ])[0-9abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ-]{17}$'
            ]}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate('VIN_INVALID', 'Numarul VIN nu este valid')
            ]}
          />
        </Box>

        <FormControlLabel
          className="m-2"
          control={
            <Switch
              id="isActive"
              checked={this.state.newVehicleVQRequery.isActive ?? false}
              onChange={(e) => this.handleIsActiveChange(e.target.checked)}
              color="primary"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label={
            <Typography variant="body2" color="textPrimary" className="font-weight-bold" align="left">
              {this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_STATE_LABEL', 'Activ')}
            </Typography>
          }
          labelPlacement="end"
        />

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'vin',
        label: this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_VIN_LABEL', 'VIN')
      },
      {
        name: 'isActive',
        label: this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_STATE_LABEL', 'Activ'),
        options: {
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names![0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names![1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => (
            <Switch
              checked={value ?? false}
              color="primary"
              onChange={(e) =>
                this.toggleVehicleVQRequeryState(tableMeta.rowData[0], e.target.checked)
              }
            />
          )
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            value ? moment.utc(value).local().format(this.props.appState.longDateFormat) : ''
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newVehicleVQRequeryPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteVehicleVQRequery(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteVehicleVQRequery = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.caseService.RemoveVehicleVQRequery(id);
      await this.loadData();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newVehicleVQRequeryPopup = async (vehicleVQRequeryId: number | null) => {
    let newVehicleVQRequery: VehicleVQRequery;
    if (vehicleVQRequeryId == null) {
      newVehicleVQRequery = { ...this.state.newVehicleVQRequery } as VehicleVQRequery;
    } else {
      newVehicleVQRequery = this.state.vehicleVQRequeryList.find(
        (item) => item.id === vehicleVQRequeryId
      )!;
    }
    this.setState({
      isDialogOpen: true,
      newVehicleVQRequery: newVehicleVQRequery,
      newVehicleVQRequeryId: vehicleVQRequeryId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newVehicleVQRequery: this.newVehicleVQRequery
    });
  };

  openImportDialog = async () => {
    this.setState({
      isImportDialogOpen: true,
      isLoadingImportData: false,
      attachments: [],
      importedVehicleVQRequeryList: []
    });
  };

  closeImportDialog = async () => {
    this.setState(
      {
        isImportDialogOpen: false,
        isLoading: true,
        importedVehicleVQRequeryList: [],
        attachments: []
      },
      async () => {
        await this.loadData();
      }
    );
  };

  handleDeleteAttachment = (id: number) => {
    const attachments = this.state.attachments.filter((a) => a.id !== id);
    this.setState({ attachments });
  };

  handleUploadFileSelected = (file: File) => {
    const attachments = [...this.state.attachments];
    attachments.push({
      id: 0,
      file,
      fileName: file.name,
      uploadDate: new Date(),
      originalFileName: file.name
    });
    this.setState({ attachments });
  };

  handleUploadFileRemoved = () => {
    const attachment = this.state.attachments[0];
    if (attachment) {
      this.handleDeleteAttachment(attachment.id);
    }
  };

  renderInfoRow = (
    iconNode: React.ReactNode,
    iconBgColor: string,
    title: string,
    description: React.ReactNode,
    actionNode: React.ReactNode
  ) => (
    <Paper
      variant="outlined"
      className="p-3 mb-3 d-flex flex-row align-items-center"
      style={{ borderRadius: 8 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          width: 44,
          height: 44,
          borderRadius: 6,
          backgroundColor: iconBgColor,
          marginRight: 16
        }}
      >
        {iconNode}
      </Box>
      <Box flexGrow={1}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>
      {actionNode}
    </Paper>
  );

  renderAttachmentBox = () => {
    const attachment = this.state.attachments[0];

    return (
      <Box className="mt-2 mb-4">
        {this.renderInfoRow(
          <DescriptionOutlinedIcon style={{ color: '#FF7345' }} />,
          '#FFF5F2',
          this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_IMPORT_ALLOWED_FORMAT',
            'Format fisier acceptat: .XLSX'
          ),
          this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_IMPORT_ALLOWED_FORMAT_DESC',
            'Descarca modelul si pastreaza structura asteptata inainte de a importa VIN-urile.'
          ),
          <Button
            variant="contained"
            onClick={this.handleDownloadModel}
            disabled={this.state.isDownloading}
            color="secondary"
            startIcon={<GetAppOutlinedIcon />}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            {this.translatorService.Tranlate(
              'VEHICLE_VQ_REQUERY_DOWNLOAD_MODEL_BTN',
              'Descarca model'
            )}
          </Button>
        )}

        <FileUploadRow
          inputId="vehicle-vq-requery-import-file"
          title={this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_IMPORT_ADD_FILE',
            'Adauga fisier VIN-uri'
          )}
          emptyDescription={this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_IMPORT_ADD_FILE_DESC',
            'Selecteaza un fisier .xlsx'
          )}
          uploadButtonLabel={this.translatorService.Tranlate(
            'VEHICLE_VQ_REQUERY_IMPORT_UPLOAD_FILE',
            'Incarca fisier'
          )}
          accept=".xls,.xlsx"
          fileName={attachment?.originalFileName ?? null}
          onFileSelected={this.handleUploadFileSelected}
          onFileRemoved={this.handleUploadFileRemoved}
        />
      </Box>
    );
  };

  handleImport = async () => {
    if (this.state.attachments.length === 0) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'ERROR_MSG_FILE_NOT_SELECTED',
          'Va rugam sa selectati un fisier!'
        ),
        {
          variant: 'error'
        }
      );
      return;
    }
    this.setState({
      isLoadingImportData: true
    });

    const request = {
      attachments: this.state.attachments
    } as VehicleVQRequeryImportRequestDto;

    try {
      const result = await this.caseService.SaveImportedVehicleVQRequery(request);
      this.props.enqueueSnackbar(
        <div>
          <p>
            {this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_DATA_PROCESSED', 'Date tratate: ')}{' '}
            {result.totalNumber}
          </p>
          <p>
            {this.translatorService.Tranlate(
              'VEHICLE_VQ_REQUERY_TREATED_SUCCESSFULLY',
              'Tratate cu succes: '
            )}{' '}
            {result.importedNumber}
          </p>
        </div>,
        {
          variant: 'info',
          autoHideDuration: 6000
        }
      );
      this.setState({
        importedVehicleVQRequeryList: result.vehicleVQRequeryList,
        isLoadingImportData: false
      });
    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error',
        autoHideDuration: 6000
      });
      this.setState({
        isLoadingImportData: false
      });
    }
  };

  handleDownloadModel = async () => {
    if (this.state.isDownloading) {
      return;
    }
    this.setState({ isDownloading: true });
    try {
      const blob = await this.caseService.GetImportModel(
        ImportTemplateCodeEnum.VEHICLE_VQ_REQUERY_IMPORT_TEMPLATE
      );
      FileSaver.saveAs(
        blob,
        `${this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_IMPORT_FILE_NAME', 'Import VINs')}.xlsx`
      );
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } finally {
      this.setState({ isDownloading: false });
    }
  };

  getImportedColumns = () => {
    return [
      {
        field: 'vin',
        title: this.translatorService.Tranlate('VEHICLE_VQ_REQUERY_VIN_LABEL', 'VIN')
      },
      {
        field: 'importMessage',
        title: this.translatorService.Tranlate(
          'MAVO_VEHICLES_VEHICLE_IMPORT_MESSAGE',
          'Rezultat import'
        )
      }
    ];
  };

  renderImportedResultBox = () => {
    return this.state.importedVehicleVQRequeryList.length > 0 ? (
      <MaterialTable
        columns={this.getImportedColumns()}
        data={this.state.importedVehicleVQRequeryList}
        title=""
        icons={MaterialTableIcons}
        localization={getLocalization(this.translatorService)}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first',
          maxBodyHeight: 400,
          paging: false,
          sorting: false,
          search: false
        }}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />
        }}
      />
    ) : (
      ''
    );
  };

  public renderImportContent() {
    return (
      <ValidatorForm onSubmit={this.handleImport} instantValidate={true}>
        {this.renderAttachmentBox()}
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingImportData} />
        </div>
        {this.renderImportedResultBox()}
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeImportDialog}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_CLOSE_BTN', 'Renunta')}
          </Button>
          <Button
            className="m-2"
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.state.isLoadingImportData}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_BTN', 'Importa')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  private toggleVehicleVQRequeryState = async (id: number, checked: boolean) => {
    const item = this.state.vehicleVQRequeryList.find((x) => x.id === id);
    if (!item) {
      return;
    }
    const updated = { ...item, isActive: checked } as VehicleVQRequery;
    try {
      await this.caseService.UpdateVehicleVQRequery(updated);
      await this.loadData();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newVehicleVQRequeryPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.vehicleVQRequeryList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {!this.state.newVehicleVQRequeryId
                      ? this.translatorService.Tranlate(
                          'VEHICLE_VQ_REQUERY_ADD_MODAL_TITLE',
                          'Adauga VIN reimprospatare'
                        )
                      : this.translatorService.Tranlate(
                          'VEHICLE_VQ_REQUERY_UPDATE_MODAL_TITLE',
                          'Actualizeaza VIN reimprospatare'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
        {this.state.isImportDialogOpen ? (
          <Dialog
            onClose={this.closeImportDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isImportDialogOpen}
            fullScreen={true}
            fullWidth={true}
          >
            <DialogTitle
              id="customized-dialog-title"
              style={{
                color: '#ffffff',
                backgroundColor: 'var(--primary)',
                textAlign: 'center'
              }}
            >
              <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                {this.translatorService.Tranlate(
                  'VEHICLE_VQ_REQUERY_IMPORT_MODAL_TITLE',
                  'Importa date '
                )}
              </span>
              <IconButton
                aria-label="close"
                className="position-absolute"
                style={{ right: 12, top: 12, color: '#ffffff' }}
                onClick={this.closeImportDialog}
                size={'small'}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box m={1} p={1}>
                {this.renderImportContent()}
              </Box>
            </DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(VehicleVQRequeryComponent as any));
